import OrderOptimizerListParams from "../../../../../common/services/order-optimizer/list/order-optimizer-list-params";
import OrderOptimizerCargoListingFilter, {
  OrderOptimizerCargoListingOrderHumanIdFilter,
} from "./types/order-optimizer-cargo-listing-filter";
import OrderOptimizerCargoListingFilterType from "./types/order-optimizer-cargo-listing-filter-type";

const create = (
  filters: OrderOptimizerCargoListingFilter[],
  page: number,
  pageSize: number,
): OrderOptimizerListParams => {
  return {
    orderHumanId: filters.find(
      (filter) =>
        filter.type === OrderOptimizerCargoListingFilterType.ORDER_HUMAN_ID,
    )?.value as
      | OrderOptimizerCargoListingOrderHumanIdFilter["value"]
      | undefined,
    page: page,
    pageSize: pageSize,
  };
};

const orderOptimizerCargoListingLoadParamsFactory = {
  create,
};

export default orderOptimizerCargoListingLoadParamsFactory;
